<h2 mat-dialog-title>Informar altura</h2>

<div mat-dialog-content class="altura-conteudo">
  <p>A altura é usada para calcular o IMC nos seus acompanhamentos.</p>
  <mat-form-field appearance="outline">
    <mat-label>Altura em metros</mat-label>
    <input matInput inputmode="decimal" maxlength="4" placeholder="Ex.: 1,75" [(ngModel)]="altura"
      (input)="aoDigitar()">
    <span matSuffix>m</span>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="!alturaValida" (click)="salvar()">Salvar</button>
</div>